import styled from "styled-components";

/** Título de seção do painel do ambiente — usado também pela Carga na Marcenaria. */
export const SectionTitle = styled.h3`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  margin-bottom: 8px;
`;
